import InputPager from './InputPager'
export { InputPager }
